const BASE_URL = '_api/tag-manager/api/v1/tags/';
export const SITES_API = `${BASE_URL}sites/`;
export const HOSTS_API = `/${BASE_URL}hosts/`;
export const WIX_DOMAINS = ['.wix.com', '.editorx.com'];
export const HOST_NAMES = {
  EDITOR: 'EDITOR',
  EDITOR_X: 'EDITOR_X',
  ADI: 'ADI',
  APP_BUILDER: 'APP_BUILDER',
  BUSINESS_MANAGER: 'BUSINESS_MANAGER',
  BUSINESS_MANAGER_EDITOR_X: 'BUSINESS_MANAGER_EDITOR_X',
  SITES_LIST: 'SITES_LIST',
  VIEWER: 'VIEWER',
  LOGO_BUILDER: 'LOGO_BUILDER',
  ART_STORE: 'ART_STORE',
  TEMPLATES: 'TEMPLATES',
  FUNNEL: 'FUNNEL',
  DEV_CENTER: 'DEV_CENTER',
  ARENA: 'ARENA',
  LOGIN_PAGE: 'LOGIN_PAGE',
  LOGIN_PAGE_EDITOR_X: 'LOGIN_PAGE_EDITOR_X',
  LOGIN_PAGE_SYMPHONY: 'LOGIN_PAGE_SYMPHONY',
  PREMIUM: 'PREMIUM',
  PREMIUM_TAGS: 'PREMIUM_TAGS',
  PREMIUM_EDITOR_X_TAGS: 'PREMIUM_EDITOR_X_TAGS',
  SUPPORT: 'SUPPORT',
  ACCOUNT_MANAGER: 'ACCOUNT_MANAGER',
  APP_MARKET_STANDALONE: 'APP_MARKET_STANDALONE',
  COMPONENT_STUDIO: 'COMPONENT_STUDIO',
  PREMIUM_DOMAINS_WHOIS: 'PREMIUM_DOMAINS_WHOIS',
  PREMIUM_DOMAINS: 'PREMIUM_DOMAINS',
  RELEASE_NOTES: 'RELEASE_NOTES',
  PREMIUM_MP_CONTAINER: 'PREMIUM_MP_CONTAINER',
  GET_FEEDBACK: 'GET_FEEDBACK',
  MOBILE_WEB_DASHBOARD: 'MOBILE_WEB_DASHBOARD',
  STUDIO_DASHBOARD: 'STUDIO_DASHBOARD',
  CHANNELS_DASHBOARD: 'CHANNELS_DASHBOARD',
  ENTERPRISE_DASHBOARD: 'ENTERPRISE_DASHBOARD',
};
export const METASITE_APP_DEF_ID = '22bef345-3c5b-4c18-b782-74d4085112ff';
export const SHOULD_RENDER_TAGS_PER_PAGE_SPEC =
  'specs.tagManagerRenderTagByPageID';
export const READ_LOAD_ONCE_FROM_TAG_SPEC =
  'specs.tagManager.ReadLoadOnceFromTag';
